export default __webpack_public_path__ + "static/rsz_kacper-b0e0da060a810bdca30fbf9e17f37b20.jpg";